import React from 'react';
import { Link } from 'react-router-dom';

const Disclaimer = () => {
    return (
        <div style={styles.container}>
            <div style={styles.content}>
                <h1 style={styles.title}>Disclaimer</h1>
                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Big Rig USA Disclaimer</h2>
                    <p style={styles.text}>
                        lawsuitfortruckaccident.com is a website dedicated to serving the public as an informational resource, providing accurate content about various medical treatments and associated side effects. lawsuitfortruckaccident.com also connects users with its legal partners, who can evaluate whether an individual has a legal case as a result of side effects or complications caused by a medical treatment.
                    </p>
                    <p style={styles.text}>
                        lawsuitfortruckaccident.com is not affiliated with any pharmaceutical companies or drug manufacturers and does not accept advertising or host online advertisements.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Service Provider Connections</h2>
                    <p style={styles.text}>
                        There may be times when a visitor comes to lawsuitfortruckaccident.com looking for assistance with a drug or medical device and Big Rig USA determines that visitor would be better served by a trusted outside service provider or law firm. In those cases, the visitor may be contacted directly by that provider or firm.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Consent to Contact</h2>
                    <p style={styles.text}>
                        By submitting a form about a specific drug or medical device, you consent to be contacted by a Big Rig USA representative or a representative from the appropriate service provider. Any information provided to lawsuitfortruckaccident.com will be shared with the service provider. Information provided to lawsuitfortruckaccident.com will not be shared, sold or provided to a data collection company unless specifically authorized.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Updated Information</h2>
                    <p style={styles.text}>
                        lawsuitfortruckaccident.com is continually updated to ensure current information about medications and medical devices and associated side effects is provided to the public. The information on the site is meant to complement a doctor or healthcare professional's advice and should not be used in place of medical advice. It is important to note that most, if not all, drugs or medical devices discussed on lawsuitfortruckaccident.com are FDA approved.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Medical and Legal Advice</h2>
                    <p style={styles.text}>
                        Content found on lawsuitfortruckaccident.com should not be taken as medical advice and site visitors are encouraged to speak with a medical professional for medical treatment, information and recommendations.
                    </p>
                    <p style={styles.text}>
                        Furthermore, site visitors should not discontinue use of a drug or medical device without first seeking the advice of medical professional.
                    </p>
                    <p style={styles.text}>
                        Additionally, the legal information on lawsuitfortruckaccident.com should not be taken as legal advice, as the content on the site is meant to provide general legal information and is not intended to provide information about a specific visitor's situation. The information on lawsuitfortruckaccident.com is not an offer to create an attorney-client relationship or perform legal services. Visitors should not act or refrain from acting due to information found on this site without the guidance of a qualified and licensed attorney.
                    </p>
                </div>

                <div style={styles.section}>
                    <h2 style={styles.sectionTitle}>Important Notice</h2>
                    <p style={styles.text}>
                        Please seek the advice of a medical professional before making health care decisions.
                    </p>
                </div>

                <Link to="/" style={styles.backLink}>
                    ← Back to Home
                </Link>
            </div>
        </div>
    );
};

const styles = {
    container: {
        minHeight: '100vh',
        backgroundColor: '#f8f5ee',
        padding: '40px 20px',
        fontFamily: 'Poppins, sans-serif',
    },
    content: {
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
        textAlign: 'left',
    },
    title: {
        fontSize: '2.5rem',
        color: '#000000',
        marginBottom: '30px',
        textAlign: 'left',
    },
    section: {
        marginBottom: '30px',
        textAlign: 'left',
    },
    sectionTitle: {
        fontSize: '1.5rem',
        color: '#000000',
        marginBottom: '15px',
        textAlign: 'left',
    },
    text: {
        fontSize: '1rem',
        lineHeight: '1.6',
        color: '#333',
        marginBottom: '15px',
        textAlign: 'left',
    },
    backLink: {
        display: 'inline-block',
        marginTop: '30px',
        color: '#000000',
        textDecoration: 'none',
        fontSize: '1rem',
        fontWeight: '500',
        transition: 'color 0.3s ease',
        textAlign: 'left',
    },
};

export default Disclaimer; 